import React, { Suspense, useContext } from 'react';
import 'twin.macro';
import { TitleRow } from '../text';
import { Loading } from '../loading';
import { ItemsGrid, ItemsList } from '../items';
import { PreferenceContext } from '../context';
import { mutateDate } from '../../lib/helpers';

const getDayTitle = (date) =>
  date
    .toLocaleString('nl-NL', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
    .replace('.', '');

const dateToppersFormatPageTitle = (date, type) => {
  switch (type) {
    case 'dag':
      return getDayTitle(date);
    case 'week':
      date.setDate(date.getDate() - date.getDay());
      return `WEEK VAN ${getDayTitle(date)}`;
    case 'maand':
      return date.toLocaleString('nl-NL', { month: 'long', year: 'numeric' });
  }
};

export const ItemsGridList = ({
  listType,
  period,
  tag,
  currentPageNum,
  date,
  hideLoadMore,
  hideAds = false,
}) => {
  const {
    preference: {
      landscape,
      nsfwActive,
      filter,
      sorting: { search: searchSortPref },
    },
  } = useContext(PreferenceContext);
  const currentDate = mutateDate(new Date(), period, -currentPageNum);
  return (
    <Suspense
      fallback={
        <ItemsGrid>
          <Loading itemPlaceholder hideAds={hideAds} />
        </ItemsGrid>
      }
    >
      <div>
        {currentPageNum > 0 && listType === 'toppers' && period !== '' && (
          <TitleRow
            sticky
            tw='transition-none flex items-center pb-0 max-w-[250px] md:max-w-[350px]'
          >
            {dateToppersFormatPageTitle(currentDate, period)}
          </TitleRow>
        )}
        <ItemsList
          maxNumItems={hideLoadMore ? 200 : 24}
          page={currentPageNum}
          landscape={landscape}
          listType={listType}
          period={period}
          nsfwActive={nsfwActive}
          filter={filter}
          searchTag={tag}
          date={date}
          sorting={searchSortPref}
          hideLoadMore={hideLoadMore}
          hideAds={hideAds}
        />
      </div>
    </Suspense>
  );
};
